module.exports = __webpack_public_path__ + "img/acreditacion_2.f0c89411.png";